// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"CriterionCreateUpdate_subTitle__OI-6I","rowSpace":"CriterionCreateUpdate_rowSpace__3mnmY"};